const DROPDOWN_GAP = 4;

/**
 * Compute the absolute-position offsets for the discover typeahead dropdown and
 * its backdrop from a `measureInWindow` result.
 *
 * `measureInWindow` returns window coordinates, so `y` already includes the top
 * safe-area inset. The dropdown is absolutely positioned inside a
 * `SafeAreaView edges={['top']}` container that is itself pushed down by that
 * same inset, so the inset must be subtracted here to avoid counting it twice
 * (which detached the dropdown ~44-59px below the search bar on notched devices).
 *
 * `insetTop` is 0 on web / non-notched devices, making this a no-op there.
 */
export const dropdownOffsets = (y: number, height: number, insetTop: number) => {
  const searchBarBottom = y + height - insetTop;
  return {
    searchBarBottom,
    dropdownTop: searchBarBottom + DROPDOWN_GAP,
  };
};
